import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { ErrorPage, Notification, SplashScreen } from "../components";
import { SwitchContent } from "./SwitchContent";
import { fetchConfig, fetchConfigEnded, getConfig } from "../modules/configuration";
import { fetchMessages, getLocale, getMessages, setLocale } from "../modules/language";
import { fetchElencoProntoSoccorso, fetchElencoProntoSoccorsoEnded, getElencoProntoSoccorso } from "../modules/prontoSoccorso";
import { resetNotification } from "../modules/notification";
import { EncounterNotification } from "../components/pages/monitoraggio/";
import { NOT_AVAILABLE_URL } from "../apiUrl";
import axios from "axios";

export const Index = () => {
  const dispatch = useDispatch();
  const [waitingComplete, setWaitingComplete] = useState(false);
  const [loadingError, setLoadingError] = useState(false);
  const [notAvailableHtml, setNotAvailableHtml] = useState(null);
  const config = useSelector(getConfig);
  const configEnded = useSelector(fetchConfigEnded);
  const elencoPs = useSelector(getElencoProntoSoccorso);
  const elencoPsEnded = useSelector(fetchElencoProntoSoccorsoEnded);
  const locale = useSelector(getLocale);
  const messages = useSelector(getMessages);

  const retryLoading = () => {
    dispatch(resetNotification());
    setWaitingComplete(false);
    setLoadingError(false);
    if (!config) dispatch(fetchConfig());
    if (elencoPs.length === 0) dispatch(fetchElencoProntoSoccorso());
    if (messages == null) dispatch(fetchMessages(locale));
  };

  useEffect(() => {
    if (!config && !configEnded) dispatch(fetchConfig());
    // eslint-disable-next-line
  }, [config, configEnded]);

  useEffect(() => {
    if (!elencoPs && !elencoPsEnded) dispatch(fetchElencoProntoSoccorso());
    // eslint-disable-next-line
  }, [elencoPs, elencoPsEnded]);

  useEffect(() => {
    if (!locale) dispatch(setLocale(navigator.language));
    // eslint-disable-next-line
  }, [locale]);

  useEffect(() => {
    if (config && elencoPs) {
      if (messages != null && !waitingComplete) setWaitingComplete(true);
      if (!waitingComplete) {
        const timeout = setTimeout(() => {
          setLoadingError(false);
          setWaitingComplete(true);
        }, 1000);
        return () => clearTimeout(timeout);
      }
    } else {
      if (configEnded && elencoPsEnded) {
        const timeout = setTimeout(() => {
          if (!waitingComplete) setWaitingComplete(true);
          setLoadingError(true);
        }, 1000 * 5);
        return () => clearTimeout(timeout);
      }
    }
    // eslint-disable-next-line
  }, [config, configEnded, elencoPs, elencoPsEnded, locale, waitingComplete, messages, notAvailableHtml]);

  useEffect(() => {
    if (config?.notAvailable) {
      if (!notAvailableHtml) axios.get(NOT_AVAILABLE_URL).then((res) => setNotAvailableHtml(res.data));
      else {
        if (window.ReactNativeWebView != null) {
          document.getElementsByClassName("header")[0].style.display = "none";
          document.getElementsByClassName("footer")[0].style.display = "none";
          document.getElementsByClassName("content")[0].style.height = "100%";
        }
      }
    }
  }, [config, notAvailableHtml]);

  return (
    locale && (
      <IntlProvider messages={messages} locale={locale}>
        <Notification />
        <EncounterNotification />
        {waitingComplete ? (
          !loadingError ? (
            config?.notAvailable ? (
              <div dangerouslySetInnerHTML={{ __html: notAvailableHtml }} style={{ height: "100%" }} />
            ) : (
              <BrowserRouter>
                <SwitchContent />
              </BrowserRouter>
            )
          ) : (
            <ErrorPage onRetry={retryLoading} />
          )
        ) : (
          <SplashScreen />
        )}
      </IntlProvider>
    )
  );
};
